var klaviyo = klaviyo || [];
klaviyo.init({
  account: "PHnWPA",
  platform: "shopify",
  collection_urls: ["/collections/", "/", "/products/"],
});
klaviyo.enable("backinstock", {
  trigger: {
    replace_anchor: false,
    collection_page_text: "Notify Me",
    collection_page_class:
      "button button--full-width button--secondary quick-add__submit",
    collection_page_padding: "0.8rem",
  },
  modal: {
    headline: "{product_name}",
    body_content:
      "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email",
    button_label: "Notify me",
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: "",
    additional_styles: `@font-face { font-family: 'AveriaSerifLibre'; src: url("//forceofnature.com/cdn/shop/files/font-AveriaSerifLibre-Bold.woff2?v=17951931210453202806") format('woff2'); font-weight: bold; font-style: normal; }`,
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#231f20",
    button_text_color: "#fff",
    button_background_color: "#231f20",
    close_button_color: "#231f20",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    font_family: '"AveriaSerifLibre", serif',
  },
});

document.addEventListener(
  "load",
  function () {
    document.querySelectorAll(".klaviyo-button-container").forEach((button) => {
      // remove styles
      button.style = "";
    });
  },
  true
);

document.addEventListener(
  "click",
  function (event) {
    if (document.body.classList.contains("variant-sticky-cart")) {
      const element = event.target;
      if (
        element.hasAttribute("data-cart-items-open") ||
        element.hasAttribute("data-cart-drawer-close")
      ) {
        const cartDrawer = element.closest("cart-drawer");
        cartDrawer.classList.toggle("open-cart");
      }

      if (element.classList.contains("nav-icon")) {
        window.location = element.closest("a").href;
      }
    }
  },
  true
);
document.addEventListener("split_test_pro_experiment_activated", function () {
  const cartDrawer = document.querySelector("cart-drawer");
  const cartDrawerItems = document.querySelector("cart-drawer-items");

  // Only remove is-empty if cart actually has items
  const cartForm = document.querySelector("#CartDrawer-Form");
  const hasItems = cartForm && cartForm.querySelector(".cart-item") !== null;

  if (hasItems) {
    cartDrawer.classList.remove("is-empty");
    cartDrawerItems.classList.remove("is-empty");
  }
});
